import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import HomeCard from '../../components/HomeCard';
import AccordionToggle from '../../components/AccordionToggle';

const styles = css`
`;

function Homes({ homes }) {
  return (
    <div className={styles}>
      {
        homes.length > 0 &&
        <div className="DetailSection">
          <div className="ScrollTarget" id="homes" />
          <AccordionToggle
            openOnId="homes"
            button={({ contentVisible }) => (
              <div className="container DetailSection_headingWrapper">
                <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Quick Move-In Homes</h3>
              </div>
            )}
            onClick={() => moveTo('#homes')}
            noToggleDesktop
          >
            <div className="container">
              <div className="row justify-content-center">
                {
                  homes.map(home => (
                    <HomeCard home={home} key={home._id} />
                  ))
                }
              </div>
            </div>
          </AccordionToggle>
        </div>
      }
    </div>
  );
}

Homes.propTypes = {
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData(
  {
    homes: true,
  },
  {
    required: {
      homes: true,
    },
  },
)(Homes);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/Homes.js